import React, {useState} from "react";
import {Button, Col, Row} from "react-bootstrap";
import { Formik, Form, Field } from 'formik';

import { setIndicators} from "services/Indicators.service";
import { useParams} from "react-router";
import {i18n} from "translate/i18n";
import {swalBadRequest, swalSuccess, swalWarning} from "../Swal";
import {setGoal} from "../../services/Goals.service";
import {
    optionsRespondent,
    optionsDefault,
    optionsTranslate,
    getStep,
    optionsLeader,
    optionsAvesso,
    optionsSuzano,
    optionsSuzanoEn,
    optionsGoalPT,
    optionsGoalEN
} from 'utils'
import {useUser} from "../../store/providers/app";
import {useQueryClient} from "react-query";
import {setLog} from "../../services/Logs.service";

const FormValidate = ({ handleClose, title, status, idDb, show, param, language }) => {

    let { id } = useParams();
    const queryClient = useQueryClient()
    const {user} = useUser();

    const idSearch = id ?? idDb

    const [loading, setLoading] = useState(false)

    const validateUser = (values, title) => {

        const data = { status: values.status, username: user.username }

        if(status === values.status) {
            swalWarning(`${i18n.t('warning.differentStatus')}`).then(() => {} )
            return
        }

        if( values.status === '') {
            swalBadRequest().then(() => {} )
            return
        }

        let newStatus = i18n.t(`header.${values.status}`)

        if (param === 'goal') {

            setGoal(idSearch, data)
                .then(response => {
                    if (response.data.success) {

                        setLog({
                            'title': 'STAGE_ADVANCEMENT',
                            'description': 'Meta movimentada de ' + getStep(status) + ' para ' + getStep(values.status),
                            'username': user.username,
                            'indicator_id': idSearch,
                        }).then((response) => {});

                        queryClient.invalidateQueries(['goals_list', status, 1, ''])
                        queryClient.invalidateQueries(['goals_list', values.status, 1, ''])

                        queryClient.invalidateQueries(["step_widget", status])
                        queryClient.invalidateQueries(["step_widget", values.status])

                        queryClient.invalidateQueries(["step", idSearch, show])

                        swalSuccess(
                            `${i18n.t('formModal.goal')} <b>${title}</b> ${i18n.t('formModal.migrate')} 
                                <b className="text-uppercase">${i18n.t(`header.${status}`)}</b> ${i18n.t('formModal.to')}  
                                <b className="text-uppercase">${newStatus}</b>`
                        )
                            .then((e) => handleClose('ok'))
                    }
                }).catch(() => swalBadRequest().then(() => { return false } ))
        } else {
            setIndicators(idSearch, data)
                .then(response => {

                    if (response.data.success) {

                        setLog({
                            'title': 'STAGE_ADVANCEMENT',
                            'description': 'Indicador movimentado de ' + getStep(status) + ' para ' + getStep(values.status),
                            'username': user.username,
                            'indicator_id': idSearch,
                        }).then((response) => {});

                        queryClient.invalidateQueries(["indicators", status, 1, ''])
                        queryClient.invalidateQueries(["indicators", values.status, 1, ''])

                        queryClient.invalidateQueries(["step", idSearch, show])

                        swalSuccess(
                            `${i18n.t('formModal.indicator')} <b>${title}</b> ${i18n.t('formModal.migrate')} 
                                <b className="text-uppercase">${i18n.t(`header.${status}`)}</b> ${i18n.t('formModal.to')}  
                                <b className="text-uppercase">${newStatus}</b>`
                        )
                            .then((e) => handleClose('ok'))
                    }
                })
                .catch(() => swalBadRequest().then(() => { return false } ))
        }
    }

    return (
        <>
            {loading ?
                <div className="d-flex justify-content-center">
                    <span className="spinner-border" role="status"/>
                </div>
                :
                <>
                    <p className="text-center">
                        {param === 'goal' ? i18n.t('formModal.questionMigrate1Goal') : i18n.t('formModal.questionMigrate1')}
                        <b> {title}</b>, {i18n.t('formModal.questionMigrate2')} <b className="text-uppercase"> { i18n.t(`header.${status}`) } </b>
                        {i18n.t('formModal.questionMigrate3')}
                    </p>

                    <Formik
                        initialValues={{
                            status: status
                        }}
                        onSubmit={values => {
                            validateUser(values, title)
                        }}
                    >
                        {({ errors, touched, values }) => (
                            <Form>
                                <Row className="justify-content-center pb-3">
                                    <Col xl={8}>
                                        <div className="form-group">
                                            <Field
                                                className="form-select"
                                                name="status"
                                                as="select"
                                                value={values.status}
                                            >
                                                <option value="">Selecione</option>

                                                { param === 'goal' && language === 'pt-BR' &&
                                                    optionsGoalPT.map((option,index) => (
                                                        <option key={index} value={option.value}>{option.label}</option>
                                                    ))
                                                }

                                                { param === 'goal' && language === 'en-US' &&
                                                    optionsGoalEN.map((option,index) => (
                                                        <option key={index} value={option.value}>{option.label}</option>
                                                    ))
                                                }

                                                { user.profile === 1 && param === 'indicator' &&
                                                    optionsDefault.map((option,index) => {
                                                        if(option.lang !== language) return
                                                        return(
                                                            <option key={index} value={option.value}>{option.label}</option>
                                                        )})
                                                }

                                                { user.profile === 2 && param === 'indicator' &&
                                                    optionsLeader.map((option,index) => (
                                                        <option key={index} value={option.value}>{option.label}</option>
                                                    ))
                                                }

                                                {user.profile === 3 && param === 'indicator' &&
                                                    optionsRespondent.map((option, index) => (
                                                        <option key={index} value={option.value}>{option.label}</option>
                                                    ))
                                                }

                                                {user.profile === 4 && param === 'indicator' &&
                                                    optionsAvesso.map((option, index) => (
                                                        <option key={index} value={option.value}>{option.label}</option>
                                                    ))
                                                }

                                                {user.profile === 5 && status === 'evaluation_suzano' && param === 'indicator' &&
                                                    optionsSuzano.map((option, index) => (
                                                        option.value === 'finished_en' && status === 'evaluation_suzano_en' ?
                                                            <option key={index} value={option.value}>{option.label}</option>
                                                            : option.value !== 'finished_en' &&
                                                            <option key={index} value={option.value}>{option.label}</option>
                                                    ))
                                                }

                                                {user.profile === 5 && status === 'evaluation_suzano_en' && param === 'indicator' &&
                                                    optionsSuzanoEn.map((option, index) => (
                                                        <option key={index} value={option.value}>{option.label}</option>
                                                    ))
                                                }

                                                { user.profile === 6 && param === 'indicator' &&
                                                    optionsTranslate.map((option,index) => (
                                                        <option key={index} value={option.value}>{option.label}</option>
                                                    ))
                                                }

                                            </Field>
                                        </div>

                                        <div className="d-grid gap-2 mt-3">
                                            <Button variant="primary" type="submit">Migrar</Button>
                                            <Button variant="secondary" type="button" onClick={() => handleClose()} >{i18n.t('buttons.cancel')}</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </>
            }
        </>
    )
}
export default FormValidate
